import React from 'react';

import NumberField from '../Molecules/NumberField';
import { setApp } from '../../index';
import { yearRegex, monthRegex } from '../../Utils/ValidationPatterns';

// This component is a helper for How long you live here OR How long you work for a company, and ect.
class YearMonthField extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            bothZero: false
        }
    }

    yearMonthCheck() {
        var y = document.getElementById('yearsField');
        var m = document.getElementById('monthsField');
        var yValue = y.querySelector('input').value;
        var mValue = m.querySelector('input').value;
        
        // If there's no input in year field default to zero
        if(!yValue || yValue === "") {
            y.querySelector('input').value = "0";
            y.querySelector('input').setAttribute('value', '0');
        }

        // If there's no input in month field default to zero
        if(!mValue || mValue === "") {
            m.querySelector('input').value = "0";
            m.querySelector('input').setAttribute('value', '0');
        }

        // If both zero, raise block
        if(yValue === "0" && mValue === "0") {
            this.setState({bothZero: true});
            setApp('blockZeros', true);
        }else{
            setApp('blockZeros', false);
        }
    }

    render() {
        return (
            <div className={`loanApp-form-row year-month-field ${this.state.bothZero ? "both-zero" : ""}`} onBlur={this.yearMonthCheck.bind(this)}>
                <div id="yearsField" className="col col-6">
                    <NumberField name={this.props.yearsName} label={this.props.yearsLabel} format="###" guidelines="This number is too high." pattern={yearRegex} required={true} />
                </div>
                <div id="monthsField" className="col col-6">
                    <NumberField name={this.props.monthsName} label={this.props.monthsLabel} format="##" pattern={monthRegex} required={true} guidelines="There are only 12 months in a year." />
                </div>
                <div className="hug">
                    <span className="bothzero-message error-message">
                        Both fields cannot be zero.
                    </span>
                </div>
            </div>
        )
    }
}

export default YearMonthField;